import ApplicationController from './application_controller';

export default class extends ApplicationController {
  toggleFeaturesList() {
    this.dispatch('toggleFeaturesList');
    this.element.remove();
  }
}